import { useEffect, useState } from 'react';

const SESSION_ID_KEY = 'carl_session_id';

export const useSessionId = () => {
  const [sessionId, setSessionId] = useState<number | null>(null);

  useEffect(() => {
    const existingSessionId = sessionStorage.getItem(SESSION_ID_KEY);

    if (existingSessionId) {
      setSessionId(parseInt(existingSessionId, 10));
    } else {
      const newSessionId = Math.floor(Math.random() * 999999999) + 1;
      sessionStorage.setItem(SESSION_ID_KEY, newSessionId.toString());
      setSessionId(newSessionId);
    }
  }, []);

  return sessionId;
};
